"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const SongwriterNameTooltip = () => (react_1.default.createElement(CustomToolTip_1.default, { type: '?', inverse: true, place: 'right', info: 'This is the name you use to credit yourself as a writer on songs. If you have variations of the name you write under or pseudonyms, you can search for them in the next step.' }));
exports.default = SongwriterNameTooltip;
